import React from "react";
import styles from "./ChatOutcomeCell.module.css";
import {ChatEventDTO, EventType} from "../../../../../../../api/generated";
import {ChatEventCard} from "../../../../../../elements/chatEventCard/ChatEventCard";
import {WhiteTooltip} from "../../../../../../elements/tooltip/WhiteTooltip";

export const chatOutcomeEventListInPriorityOrder: EventType[] = [
    EventType.RequestedLimitedVehicleInformation,
    EventType.RequestedLimitedVehicleValuation,
    EventType.RequestedLimitedFinanceIllustration,
    EventType.RequestedLimitedVehicleReservation,
    EventType.ReservedVehicle,
    EventType.ReturnedVehicleValuation,
    EventType.ReturnedFinanceQuote,
    EventType.ReturnedFinanceApplication,
    EventType.ReturnedUsedVehicleInformation,
    EventType.ReturnedNewVehicleInformation,
];

interface ChatOutcomeCellProps {
    chatEvents: ChatEventDTO[]
}


export const ChatOutcomeCell: React.FC<ChatOutcomeCellProps> = ({chatEvents}) => {

    const priorityMap = new Map<EventType, number>();
    chatOutcomeEventListInPriorityOrder.forEach((type, index) => {
        priorityMap.set(type, index);
    });

    const sortChatOutcomeEvents = (a: ChatEventDTO, b: ChatEventDTO) => {
        const priorityA = priorityMap.get(a.event_type) ?? Number.MAX_SAFE_INTEGER;
        const priorityB = priorityMap.get(b.event_type) ?? Number.MAX_SAFE_INTEGER;
        return priorityA - priorityB;
    };


    return <span className={styles.chatOutcomeCell}>
            {chatEvents
                .filter(chatEvent => chatOutcomeEventListInPriorityOrder.includes(chatEvent.event_type))
                .sort(sortChatOutcomeEvents)
                .slice(0, 3)
                .map(chatEvent => (
                    <ChatEventCard key={chatEvent.id} eventType={chatEvent.event_type}/>
                ))}
        {chatEvents.filter(chatEvent => chatOutcomeEventListInPriorityOrder.includes(chatEvent.event_type)).length > 3 && (
            <WhiteTooltip
                title={
                    <div className={styles.tooltipContent}>
                        {chatEvents
                            .filter(chatEvent => chatOutcomeEventListInPriorityOrder.includes(chatEvent.event_type))
                            .sort(sortChatOutcomeEvents)
                            .slice(3)
                            .map(chatEvent => (
                                <ChatEventCard key={chatEvent.id} eventType={chatEvent.event_type}/>
                            ))}
                    </div>
                }
            >
                <img src={"/infoIcon.svg"} alt={"more"} className={styles.infoIcon}/>
            </WhiteTooltip>
        )}
        </span>
}
